<ng-container [ngSwitch]="scheduleItem.type">

  <div *ngSwitchCase="'10'" class="p-1 roomClosed schedule-item" [style.height]="getPanelHeight()"
    [style.top]="getPanelTop()">
    <span>{{'CLOSED'|translate}}</span>
  </div>

  <ng-container *ngSwitchCase="'20'">
    <ng-template #content><span [innerHTML]="scheduleItem.description"></span></ng-template>

    <div class="p-1 border schedule-item" [style.backgroundColor]="scheduleItem.color" [style.opacity]="0.75"
      [style.color]="scheduleItem.textColor" [style.height]="getPanelHeight()" [style.top]="getPanelTop()"
      placement="top" [ngbTooltip]="content" #t="ngbTooltip" [disableTooltip]="!scheduleItem.description">
      <span> {{formatTimeSpan(scheduleItem)}}</span>
      <br> {{scheduleItem.designation}}
      <ng-container *ngIf="scheduleItem.description">
        <br>
        <small class="description" [innerHTML]="scheduleItem.description"></small>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'30'" [ngSwitch]="scheduleItem.isBookable">

    <!-- click to reserve -->
    <div *ngSwitchCase="true" class="schedule-item schedule-item-selectable" [style.height]="getPanelHeight()"
      [style.top]="getPanelTop()" (click)="onClickCreateReservation(scheduleItem)">
      <div class="p-1 bg-white text-black-50 border">{{scheduleItem.designation}}</div>
    </div>
    <div *ngSwitchDefault class="schedule-item schedule-item-unavailable" [style.height]="getPanelHeight()"
      [style.top]="getPanelTop()">
      <div class="p-1 bg-white text-black-50 border">{{scheduleItem.designation}}</div>
    </div>
  </ng-container>

  <!-- unreservable span -->
  <div *ngSwitchCase="'40'" class="schedule-item schedule-item-unavailable" [style.height]="getPanelHeight()"
    [style.top]="getPanelTop()">
    <div class="p-1 bg-white text-black-50 border">{{scheduleItem.designation}}</div>
  </div>

  <div *ngSwitchDefault class="p-1 schedule-item" [style.height]="getPanelHeight()" [style.top]="getPanelTop()">
    {{scheduleItem|json}}
  </div>

</ng-container>